module.exports = "/_next/static/images/2b09707443164025c0f7402c26f9795d-balance-xs.png.webp";